import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuCategoryTypeActions } from "./apu-category-type.actions";
import { ApuCategoryTypeApiModel } from "@/core/models/api/apu-category-type-api.model";
import { ApuCategoryTypeService } from "@/core/services/apu-category-type.service";

@Injectable()
export class ApuCategoryTypeEffects {
    actions$ = inject(Actions);
    apuCategoryTypeService = inject(ApuCategoryTypeService);

    constructor(){

    }

    _loadApuCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuCategoryTypeActions.loadApuCategoryTypes),
            exhaustMap(() => {
                return this.apuCategoryTypeService.getAll().pipe(
                    map((response: any) => {
                        const apuCategoryTypes = response as ApuCategoryTypeApiModel[];
                        return ApuCategoryTypeActions.loadApuCategoryTypeSuccess({ apuCategoryTypes });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuCategoryTypeActions.addRangeApuCategoryTypes),
            exhaustMap((action) => {
                return this.apuCategoryTypeService.addRange(action.apuCategoryTypes).pipe(
                    map((response: any) => {
                        const apuCategoryTypes = response as ApuCategoryTypeApiModel[];
                        return ApuCategoryTypeActions.addRangeApuCategoryTypeSuccess({ apuCategoryTypes });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}